import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "../Form";
export const SelectTableRowRadio = observer(({ id, label, name }) => {
    const { values } = useFormContext();
    const handleChange = useCallback((e) => values.set(name, id), [values, name, id]);
    return (React.createElement("label", null,
        React.createElement("input", { name: id, type: "radio", onChange: handleChange, checked: values.get(name) === id }),
        React.createElement("span", { className: "sr-only" }, label)));
});
